module.exports = __webpack_public_path__ + "img/home.d60a186f.png";